//import axios
import axios from 'axios'

const Api = axios.create({
    //set default endpoint API
    baseURL: 'https://panel.domyadhu.org/api'
})

export default Api